import React from 'react';


let RowIcons = ({ icons }) => {

    return (
        <div className="row ">
            <div className="col-12 info-options">
                {
                    (icons).map((icon, index) => (
                        <div key={index} >
                            <div className="icon-option">
                                <span>
                                    <img src={`${process.env.PUBLIC_URL}/images/svg/${icon.Image}`} alt="" />
                                </span>
                                <div className="text-option">
                                    <p>{icon.Text1}</p>
                                    <p>{icon.Text2}</p>
                                </div>
                            </div>

                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default RowIcons;
